import Swal from 'sweetalert2';
import router from '@/router';

export class CadastroCompletoHelper {
  /**
   * Verifica se o cadastro do paciente está completo
   * @param pacienteId - ID do paciente
   * @param cadastroCompleto - Status do cadastro (true/false)
   * @param onCompletarCallback - Função callback opcional para abrir modal de edição
   * @returns Promise<boolean> - true se pode prosseguir, false se deve parar
   */
  static async validarCadastroCompleto(
    pacienteId: number,
    cadastroCompleto: boolean,
    onCompletarCallback?: (pacienteId: number) => void,
  ): Promise<boolean> {
    if (cadastroCompleto) {
      return true;
    }

    const primaryColor = getComputedStyle(document.documentElement)
      .getPropertyValue('--especialidade-primary')
      .trim() || '#2e4b9d';

    const result = await Swal.fire({
      title: 'Cadastro Incompleto',
      html: 'O cadastro do(a) paciente esta incompleto, preencha os campos obrigatórios antes de prosseguir. Deseja completar o cadastro agora?',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Sim, completar cadastro',
      cancelButtonText: 'Não, continuar depois',
      confirmButtonColor: primaryColor,
      cancelButtonColor: '#d33',
      allowOutsideClick: false,
    });

    if (result.isConfirmed) {
      if (onCompletarCallback) {
        onCompletarCallback(pacienteId);
      } else {
        router.push({
          name: 'pacientesFormUpdate',
          params: { pacienteId: pacienteId.toString() },
        });
      }
    }

    return false;
  }

  /**
   * Valida se os campos obrigatórios estão preenchidos
   * @param nomeCompleto - Nome completo do paciente
   * @param dataNascimento - Data de nascimento do paciente
   * @param cpf - CPF do paciente (opcional)
   * @returns boolean - true se cadastro está completo
   */
  static validarCamposObrigatorios(
    nomeCompleto: string,
    dataNascimento: Date | string,
    cpf?: string,
  ): boolean {
    const temNomeCompleto = !!(nomeCompleto && nomeCompleto.trim());
    const temDataNascimento = !!(
      dataNascimento
      && dataNascimento !== '0001-01-01T00:00:00'
      && new Date(dataNascimento).getTime() > 0
    );
    const temCpf = !!(cpf && cpf.trim());

    return temNomeCompleto && (temDataNascimento || temCpf);
  }
}
